var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field-view pt-3"},[_c('span',{staticClass:"text-sm text-body"},[_vm._v(" "+_vm._s(_vm.prefix)+" "+_vm._s(_vm._f("blankText")(_vm.text))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }